import React, { useState } from 'react';
import { Upload, message } from 'antd';
import { Progress } from 'antd';
import './Styles/ProductRouteStyle.scss'
const BulkProduct = () => {
    let [uploadCsv, setUploadCsv] = useState([])
    console.log(uploadCsv);
    let handleClearList = () => { setUploadCsv([]) }

    // let Remove = (e) => {
    //     let removed = uploadCsv.splice(e, e );
    //     setUploadCsv(removed)
    // }
    const props = {
        name: 'file',
        multiple: true,
        action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
        onChange(info) {
            setUploadCsv(info.fileList)
            const { status } = info.file;
            if (status === 'done') { message.success(`${info.file.name} file uploaded successfully.`); }
            else if (status === 'error') { message.error(`${info.file.name} file upload failed.`); }
        },
        onDrop(e) { console.log('Dropped files', e.dataTransfer.files) },

    };

    return (
        <div className="row">
            <div className="col-lg-12"> <button className="csvBtn px-4 rounded"><i className="fas fa-arrow-down  "></i>Download Sample CSV  File</button>
            </div>
            <div className="row">

                <p className="col-lg-5 mt-2 ">Upload the completed CSV file</p>
                <p className="col-lg-7 mt-2" ><span className="proTip ">Pro Tip:</span> Uploading file with same SKU will modify existing product</p>


                <div className="col-lg-12 ">
                    <div>
                        <Upload.Dragger showUploadList={false} {...props} name="files" noStyle={false}>
                            <p className="ant-upload-drag-icon"> </p>
                            <p className="ant-upload-text">Click or drag file to this area to upload</p>
                            <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                        </Upload.Dragger>
                        <span>The resolution must be 1920X1080 and it must maintain 16:9.
                        </span>
                    </div>

                    <span className="pt-2">Queue</span>
                    <div className="queue  row bg-white">

                        {uploadCsv?.map((data, index) => <div key={index}>
                            <div className="col-lg-2 mt-3">
                                <i className="far fa-times-circle  removeIcon"></i> <span className="pt-5 ml-2 removText" >Remove</span>
                            </div>
                            <div className="col-lg-2 mt-4"> <p className="csvName" title={data.name}>{data.name}</p>  </div>
                            <div className="col-lg-2 mt-3">
                                {data.status === "done" ? <button className="bulkBtn uploaded">Uploaded</button> : data.status === "error" ?
                                    <button className=" failed bulkBtn">Failed</button> : <button className=" uploading bulkBtn">Uploading</button>}
                            </div>
                            <div className="col-lg-6 mt-4 mr-3">
                                <Progress percent={parseInt(data.percent)} />

                            </div>

                        </div>)}
                        {uploadCsv.length === 0 ? "" : <button className="btn btn-success px-4 py-3 mt-3 mb-5 col-lg-6 offset-lg-3 " onClick={handleClearList}>Clear The List</button>}

                    </div>
                </div>
            </div>
        </div>
    );
};

export default BulkProduct;